<template>
  <b-container fluid>
    <b-row>
      <b-col cols="5">
        <div class="soumission-wrapper">
          <h3>Votre Soumission</h3>
          <small>
            Statut:
            {{ GetStatus }}
          </small>

          <div class="section-title">Produits ajoutés à votre soumission</div>
          <div>
            <table border="1" cellpadding="3" style="width: 100%">
              <tr v-for="produit in soumission.products" :key="produit.id">
                <td>#{{ produit.id }}</td>
                <td>
                  <img v-if="false" :src="produit.thumbnail.startsWith('http') ? produit.thumbnail : 'http://'+produit.thumbnail.replace('plomberieparadis.com', 'localhost:8000')" style="max-width: 100px;" />
                  <img :src="produit.thumbnail.startsWith('http') ? produit.thumbnail : 'https://'+produit.thumbnail" style="max-width: 100px;" />
                </td>
                <td>{{ produit.name }}</td>
                <td>Prix: {{ produit.price }}$</td>
                <td v-if="IsSubmited()">
                  <button @click="DeleteProduct(produit.id, produit.slug)" class="btn viewBtn">
                    <font-awesome-icon icon="times" />
                  </button>
                </td>
              </tr>
            </table>
          </div>

         
          <div v-if="IsSubmited()">
             <hr />

             <div class="form-check">
              <input
                type="checkbox"
                placeholder="Préférence"
                v-model="soumission.installation_included"
                name="installation_included"
                class="form-check-input"
              />
              <label class="form-check-label" for="installation_included">Voulez-vous inclure l'intallation?</label>
            </div>
            <br/>
            <div class="form-group">
              <label>Heure de préférence pour vous contacter</label>
              <input
                type="text"
                placeholder="Heure"
                v-model="soumission.contact_time"
                name="contact_time"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label>Moyen de préférence pour vous contacter</label>
              <select
                v-model="soumission.contact_preference"
                name="contact_preference"
                class="form-control"
              >
                <option value="phone">Téléphone</option>
                <option value="email">Courriel</option>
              </select>
            </div>

          </div>

          
          <div v-if="HavePrice()">
            <hr />
            <table border="1" cellspacing="0" cellpadding="20" style="width: 100%">
              <!--<tr>
                <td>Service:</td>
                <td>50.00$</td>
              </tr>-->
              <tr v-if="installation_included">
                <td>Installation:</td>
                <td>{{ prices.installation }}$</td>
              </tr>
              <tr>
                <td>Sous-total:</td>
                <td>{{ prices.subtotal }}$</td>
              </tr>
              <tr>
                <td>TPS:</td>
                <td>{{ prices.gst }}$</td>
              </tr>
              <tr>
                <td>TVQ:</td>
                <td>{{ prices.qst }}$</td>
              </tr>
              <tr>
                <td>Transport:</td>
                <td>{{ prices.shipping }}$</td>
              </tr>
              <tr>
                <td>Total:</td>
                <td>{{ prices.total }}$</td>
              </tr>
            </table>
            <br />
            <button class="btn viewBtn" v-if="CanAccept()" @click="AcceptSoumission()">Accepter</button>
            <button class="btn viewBtn" v-if="CanRefuse()" @click="RefuseSoumssion()">Refuser</button>
          </div>
          <div v-if="IsSubmited()">
            <p>Veuillez compléter vos informations de contact pour pouvoir envoyer votre demande.</p>
            <h5>Information de contact</h5>
            <div class="form-group">
              <label>*Adresse</label>
              <input
                type="text"
                placeholder="Votre adresse"
                v-model="profil.profile.address"
                v-validate="'required'"
                name="address"
                class="form-control"
              />
              <small v-show="errors.has('addresss')">{{ errors.first('address') }}</small>
            </div>

            <div class="form-group">
              <label>*Ville</label>
              <input
                type="text"
                placeholder="Votre ville"
                v-model="profil.profile.city"
                v-validate="'required'"
                name="city"
                class="form-control"
              />
              <small v-show="errors.has('city')">{{ errors.first('city') }}</small>
            </div>

            <div class="form-group">
              <label>*Code postal</label>
              <input
                type="text"
                placeholder="Votre code postal"
                v-model="profil.profile.zip_code"
                v-validate="'required'"
                name="zip_code"
                class="form-control"
              />
              <small v-show="errors.has('zip_code')">{{ errors.first('zip_code') }}</small>
            </div>

            <div class="form-group">
              <label>*Téléphone</label>
              <input
                type="text"
                placeholder="Votre téléphone"
                v-model="profil.profile.phone"
                v-validate="'required'"
                name="phone"
                class="form-control"
              />
              <small v-show="errors.has('phone')">{{ errors.first('phone') }}</small>
            </div>

            <div class="form-group">
              <label>Message</label>
              <textarea v-model="soumission.note" placeholder="Votre message" name="message" class="form-control"></textarea>
              <small v-show="errors.has('message')">{{ errors.first('message') }}</small>
            </div>
            <button class="btn viewBtn" @click="EnvoyerSoumission()">Envoyer votre demande</button>
          </div>
        </div>
      </b-col>
      <b-col cols="7">
        <!--<ul class="menu-product" v-if="IsSubmited()">
            <li>
              <router-link :to="{ name: 'EditSoumission', params: { sid: this.$route.params.sid }}">
                <button class="btn viewBtn">Édition</button>
              </router-link>
            </li>
        </ul>-->
        <div class="plan-wrapper">
          <router-link :to="{ name: 'EditSoumission', params: { sid: this.$route.params.sid }}">
            <button class="btn viewBtn" v-if="IsSubmited()">Édition</button>
          </router-link>
          <h3>Votre plan de salle de bain</h3>
          <img :src="soumission.image" width="75%" />
        </div>
        <canvas id="floorplan" width="600" height="600" style="display: none;"></canvas>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Soumission",
  data() {
    return {
      profil: "",
      productList: [],
      soumission: "",
      is_not_accepted: true,
      is_not_refused: true,
      prices: {},
      canvas: null
    };
  },
  computed: {
    GetStatus: function() {
      var status = "";

      switch (this.soumission.status) {
        case "draft":
          status = "Brouillon";
          break;
        case "submit":
          status = "Envoyé";
          break;
        case "waiting":
          status = "En attente";
          break;
        case "replied":
          status = "Répondu";
          break;
        case "accepted":
          status = "Accepté";
          break;
        case "refused":
          status = "Refusé";
          break;
        case "closed":
          status = "Fermée";
          break;
      }

      return status;
    }
  },
  methods: {
    GetInstallation() {
      console.log(this.installation_included)
    },
    CanDeleteProduct: function() {
      if (this.soumission.status == "draft") {
        return true;
      } else {
        return false;
      }
    },
    DeleteProduct: function(produit_id, slug = null) {
      this.$bvModal
        .msgBoxConfirm("Voulez-vous vraiment vous supprimer ce produit?", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true
        })
        .then(value => {
          if (value) {
            var data = { id: produit_id };

            if (localStorage.getItem("token")) {
              var dheader = {
                "Content-Type": "application/json",
                Authorization: "Token " + localStorage.getItem("token")
              };
            } else {
              var dheader = { "Content-Type": "application/json" };
            }

            this.$http
              .post(
                this.$url_name +
                  "/submission/" +
                  this.$route.params.sid +
                  "/delete_product/",
                data,
                {
                  headers: dheader
                }
              )
              .then(response => {
                this.UpdatePlanImage(slug);
              })
              .catch(err => {
                console.log(err);
              });
          }
        });
    },
    CanAccept: function() {
      if (
        this.soumission.status != "draft" &&
        this.soumission.status != "submit" &&
        this.soumission.status != "accepted" &&
        this.soumission.status != "refused"
      ) {
        return true;
      } else {
        return false;
      }
    },
    CanRefuse: function() {
      if (
        this.soumission.status != "draft" &&
        this.soumission.status != "submit" &&
        this.soumission.status != "refused" &&
        this.soumission.status != "accepted"
      ) {
        return true;
      } else {
        return false;
      }
    },
    AcceptSoumission: function() {
      if (localStorage.getItem("token")) {
        var dheader = {
          "Content-Type": "application/json",
          Authorization: "Token " + localStorage.getItem("token")
        };
      } else {
        var dheader = { "Content-Type": "application/json" };
      }

      this.$http
        .patch(
          this.$url_name + "/submission/" + this.$route.params.sid + "/accept/",
          {
            headers: dheader
          }
        )
        .then(response => {
            this.LoadData()
          this.$toasted.show(
            "La soumission a bien été acceptée. Merci de votre confiance. Nous vous contacterons très bientôt.",
            {
              duration: 2000,
              type: "success"
            }
          );
        })
        .catch(err => {
          console.log(err);
        });
    },
    RefuseSoumssion: function() {
      var dheader = {
        "Content-Type": "application/json",
        Authorization: "Token " + localStorage.getItem("token")
      };

      this.$http
        .patch(
          this.$url_name + "/submission/" + this.$route.params.sid + "/refuse/",
          {
            headers: dheader
          }
        )
        .then(response => {
            this.LoadData()
          this.$toasted.show(
            "La soumission a bien été refusée.",
            {
              duration: 2000,
              type: "success"
            }
          );
        })
        .catch(err => {
          console.log(err);
        });
    },
    HavePrice: function() {
      if (
        this.soumission.status == "replied" ||
        this.soumission.status == "accepted" ||
        this.soumission.status == "refused"
      ) {
        return true;
      } else {
        return false;
      }
    },
    IsSubmited: function() {
      if (this.soumission.status == "draft") {
        return true;
      } else {
        return false;
      }
    },
    EnvoyerSoumission: function() {
      this.$validator.validate().then(result => {
        if (!result) return; // client side error detected.

        this.soumission.status = "submit";

        var data = {
          profile: {
            city: this.profil.profile.city,
            company: this.profil.profile.company,
            address: this.profil.profile.address,
            phone: this.profil.profile.phone,
            zip_code: this.profil.profile.zip_code
          }
        };

        var dheader = {
          "Content-Type": "application/json",
          Authorization: "Token " + localStorage.getItem("token")
        };

        this.$http
          .post(this.$url_name + "/accounts/profile/", data, {
            headers: dheader
          })
          .then(response => {

            var data = {
              contact_time: this.soumission.contact_time,
              contact_preference: this.soumission.contact_preference,
              installation_included: this.soumission.installation_included,
              note: this.soumission.note
            };

            this.$http
              .put(
                this.$url_name + "/submission/" + this.$route.params.sid + '/',
                data,
                {
                  headers: dheader
                }
              )
              .then(response => {
            
                //now send soumission
                this.profil = response.body;

                data = { copy_user_infos: true };

                this.$http
                  .patch(
                    this.$url_name +
                      "/submission/" +
                      this.$route.params.sid +
                      "/submit/",
                    data,
                    {
                      headers: dheader
                    }
                  )
                  .then(response => {
                    this.$toasted.show(
                      "Votre demande de soumission a bien été envoyé! Nous vous répondrons rapidement.",
                      {
                        duration: 2000,
                        type: "success"
                      }
                    );
                  })
                  .catch(err => {
                    console.log(err);
                  });
              })
              .catch(err => {
                console.log(err);
              });
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    UpdatePlanImage: function(slug) {
        this.canvas = new fabric.Canvas("floorplan", {
            selection: false
        });
        var c_width = this.soumission.width * (600 / this.soumission.width) + 20;
        var c_height = this.soumission.height * (600 / this.soumission.width) + 20;
        this.canvas.setDimensions({ width: c_width, height: c_height });
        this.soumission.plan.objects.forEach((item, index, object) => {
            if (item.id && item.id == slug) {
                object.splice(index, 1)
            }
        })
        this.canvas.loadFromJSON(this.soumission.plan);
        this.canvas.renderAll();
        setTimeout(() => {
            var data = {
                image_encoded: this.canvas.toDataURL("png"),
                plan: this.canvas.toJSON([
                    "_controlsVisibility",
                    "lockRotation",
                    "lockMovementX",
                    "lockMovementY",
                    "lockScalingX",
                    "lockScalingY",
                    "lockUniScaling",
                    "selectable",
                    "lockType",
                    "lock",
                    "id",
                    "sid",
                    "obj_type"
                ])
            };
            this.LoadData();
            if (localStorage.getItem("token")) {
                var dheader = {
                    "Content-Type": "application/json",
                    Authorization: "Token " + localStorage.getItem("token")
                };
            } else {
                var dheader = { "Content-Type": "application/json" };
            }
            this.$http.put(
                this.$url_name + "/submission/" + this.$route.params.sid + "/",
                data, {headers: dheader}
            )
            .then(response => {
                this.soumission = response.body;
                this.saving = "";
                this.canvas_modified = false;
            })
            .catch(err => {
                console.log(err);
            });
        }, 500)
    },
    LoadData: function() {
      if (localStorage.getItem("token")) {
        var dheader = {
          "Content-Type": "application/json",
          Authorization: "Token " + localStorage.getItem("token")
        };
      } else {
        var dheader = { "Content-Type": "application/json" };
      }

      this.$http
        .get(this.$url_name + "/submission/" + this.$route.params.sid + "/", {
          headers: dheader
        })
        .then(response => {
          if (response.body) {
            this.soumission = response.body;

            if (this.HavePrice()) {
              var dheader = {
                "Content-Type": "application/json",
                Authorization: "Token " + localStorage.getItem("token")
              };

              this.$http
                .get(
                  this.$url_name +
                    "/submission/" +
                    this.$route.params.sid +
                    "/cost/",
                  {
                    headers: dheader
                  }
                )
                .then(response => {
                  if (response.body) {
                    this.prices = response.body;
                  }
                })
                .catch(err => {
                  console.log(err);
                });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });

      //Load profil data

      var dheader = {
        "Content-Type": "application/json",
        Authorization: "Token " + localStorage.getItem("token")
      };

      this.$http
        .get(this.$url_name + "/accounts/profile/", {
          headers: dheader
        })
        .then(response => {
          this.profil = response.body;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.LoadData();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.legende button {
  width: 100%;
}
.plan-wrapper {
  background-color: #eeeeee;
  padding: 25px;
}
.soumission-wrapper {
  height: 700px;
  overflow: auto;
  padding-right: 20px;
  padding-top: 25px;
}
.menu-product {
  list-style-type: none;
  padding-left: 0px;
  margin-bottom: 5px;
}
.menu-product li {
  padding-bottom: 0;
}
@media (max-width: 999px) {
  .boxRight .col-4 {
    display: block;
    width: 100%;
    max-width: calc(100% - 30px);
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
  }
  .boxRight .col-8 {
    display: block;
    width: 100%;
    max-width: calc(100% - 30px);
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
  }
  .boxRight .col-4 .soumission-wrapper {
    height: auto;
    padding: 0 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Soumission.vue